"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentController = /** @class */ (function () {
    function StudentController(currentUser, ENV) {
        this.ENV = ENV;
        this.currentUser = currentUser;
        this.school = this.currentUser.school;
    }
    return StudentController;
}());
StudentController.$inject = ["currentUser", "ENV"];
exports.default = StudentController;
